<template>
  <div style="
      height: calc(100vh - 53px);
      display: flex;
      align-items: center;
      justify-content: center;
      background-size: cover;
    " :style="
      $store.state.user.level == 'İlkokul'
        ? 'background-image: url(/static/images/kid.jpg)'
        : ''
    ">
    <el-drawer :destroy-on-close="true" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
      :with-header="false" class="aaaa">
      <div class="row p-5">
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Hız</label>
          <el-slider style="display: flex; flex: 1" v-model="speed" :min="0.7" :max="2" :step="0.1"></el-slider>
        </div>
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Dış Çizgi Vurgusu</label>
          <el-slider style="display: flex; flex: 1" v-model="config.borderOpacity" :min="0" :max="100"
            :step="5"></el-slider>
        </div>
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Arka Renk Vurgusu</label>
          <el-slider style="display: flex; flex: 1" v-model="config.backgroundOpacity" :min="0" :max="100"
            :step="5"></el-slider>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Renklendirme</label>
          <el-radio-group v-model="colorMode">
            <el-radio v-for="item in [
                'Yok',
                'İlk Hece Renkli',
                'Son Hece Renkli',
                'İlk ve Son Hece Renkli',
              ]" :label="item" :key="item" :value="item"></el-radio>
          </el-radio-group>
        </div>

        <div class="col-md-12 mt-4">
          <label for="">Hece Modu</label>
          <el-radio-group v-model="heceModu">
            <el-radio v-for="item in [
                'Yok',
                'İlk Hece Noktalı',
                'İlk Hece Altı Çizili',
                'Son Hece Noktalı',
                'Son Hece Altı Çizili',
              ]" :label="item" :key="item" :value="item"></el-radio>
          </el-radio-group>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Hece Vurgu Rengi</label>
          <el-color-picker color-format="rgb" show-alpha v-model="heceRengi"></el-color-picker>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
      <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="settings" style="top: 40px">
        <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
      </a>

      <a href="javascript:;" @click.stop="settings = true" class="settings">
        <i class="el-icon-setting"></i>
      </a>

      <h1 v-if="kelimedakika != 0" style="
          position: absolute;
          top: -30px;
          left: 0px;
          font-size: 20px;
          font-weight: bold;
          color: #333;
        ">
        {{ parseInt(kelimedakika) }}
        Kelime/Dakika
      </h1>

      <div style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: center;
          margin-top: -30px;
          margin-bottom: -23px;
        ">
        <lottie :options="defaultOptions" :height="372" :width="304" v-on:animCreated="handleAnimation"
          v-if="part <= parts.length" />
      </div>

      <div v-if="!isPlaying" @click="getTts(parts[part - 1].metin)" style="
          position: absolute;
          top: 10px;
          left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          cursor: pointer;
          z-index: 9999999;
        ">
        <i class="fas fa-redo-alt"></i>
        <span>Tekrar Dinle</span>
      </div>

      <lottie style="position: absolute; top: 0; left: 0; z-index: 1" :options="defaultOptions2" :height="500"
        :width="600" v-on:animCreated="handleAnimation2" />

      <transition-group name="flip-list" tag="div" style="
          padding: 30px;
          font-size: 19px;
          display: flex;
          flex-direction: row;
          width: 100%;
          flex-wrap: wrap;
          z-index: 999;
          margin-top: -50px;
        " v-if="part <= parts.length">
        <template v-for="index in part" :style="{}" style="display: inline-block">
          <div :key="index + '-' + wordIndex" enter-stagger="50" leave-stagger="0" transition="fade" class="dark-inverted"
            :class="'word ' + 'word-' + wordIndex + '-' + index"
            v-for="(word, wordIndex) in parts[index - 1].metin.split(' ')" style="
              display: inline-block;
              padding-right: 2.5px;
              cursor: pointer;
              padding-left: 2.5px;
              font-size: 21px;
              position: relative;
            " :style="{
              color: parts[index - 1].skipIndexes.some((x) => x == wordIndex)
                ? 'red !important'
                : parts[index - 1].completedIndexes.some((x) => x == wordIndex)
                ? 'blue !important'
                : parts[index - 1].pendingIndexes.some((k) => k == wordIndex)
                ? 'orange !important'
                : 'black !important',
              textDecoration: parts[index - 1].completedIndexes.some(
                (x) => x == wordIndex
              )
                ? 'underline'
                : '',
              opacity:
                parts[index - 1].completedIndexes.length ==
                parts[index - 1].fix.length
                  ? 0.4
                  : 1,
              background:
                currentMark == wordIndex && index == part
                  ? 'rgba(255,255,255,' + config.backgroundOpacity / 100 + ')'
                  : '',
              borderRadius: '5px',
              border:
                currentMark == wordIndex && index == part
                  ? '1px solid rgba(0,0,0,' + config.borderOpacity / 100 + ')'
                  : '1px solid transparent',
            }" @click="check(word, index, wordIndex)">
            {{ word }}

            <span v-if="colorMode.indexOf('İlk') != -1" style="
                color: transparent;
                position: absolute;
                left: 2.5px;
                bottom: 0px;
              " :style="{ color: heceRengi }">{{ parts[index - 1].heceler[wordIndex][0] }}</span>
            <span v-if="colorMode.indexOf('Son') != -1" style="
                color: transparent;
                position: absolute;
                right: 2.5px;
                bottom: 0px;
              " :style="{ color: heceRengi }">{{
              parts[index - 1].heceler[wordIndex][
              parts[index - 1].heceler[wordIndex].length - 1
              ]
              }}</span>
            <span v-if="heceModu == 'İlk Hece Altı Çizili'" style="
                color: transparent;
                position: absolute;
                left: 2.5px;
                bottom: 0px;
                height: 0px;
              " :style="{ borderBottom: '1px solid ' + heceRengi }">{{ parts[index - 1].heceler[wordIndex][0] }}</span>

            <span v-if="heceModu == 'İlk Hece Noktalı'" style="
                color: transparent;
                position: absolute;
                left: 2.5px;
                bottom: 0px;
                height: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              ">{{ parts[index - 1].heceler[wordIndex][0]
              }}<span style="
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  position: absolute;
                " :style="{ backgroundColor: heceRengi }"></span></span>

            <span v-if="heceModu == 'Son Hece Altı Çizili'" style="
                color: transparent;
                position: absolute;
                right: 2.5px;
                bottom: 0px;
                height: 0px;
              " :style="{ borderBottom: '1px solid ' + heceRengi }">{{
              parts[index - 1].heceler[wordIndex][
              parts[index - 1].heceler[wordIndex].length - 1
              ]
              }}</span>

            <span v-if="heceModu == 'Son Hece Noktalı'" style="
                color: transparent;
                position: absolute;
                right: 2.5px;
                bottom: 0px;
                height: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              ">{{
              parts[index - 1].heceler[wordIndex][
              parts[index - 1].heceler[wordIndex].length - 1
              ]
              }}<span style="
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  position: absolute;
                " :style="{ backgroundColor: heceRengi }"></span></span>
          </div>
        </template>
      </transition-group>
      <div v-else style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 47px;
          flex-direction: column;
          z-index: 99999;
        ">
        <h1 class="dark-inverted">{{ $t("module.level_completed") }}</h1>
        <h1 class="dark-inverted" style="font-size: 50%; margin-top: 10px">
          {{ $t("module.point") }} {{ totalTrue * 5 - totalFalse }}
        </h1>
        <el-button type="primary" class="mt-5" round @click="start">{{
          $t("module.continue")
          }}</el-button>
      </div>

      <div style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          position: absolute;
          z-index: 99999;
          bottom: 0px;
          left: 0px;
        ">
        <div v-for="option in options" @click="pickOption(option)" style="
            display: flex;
            flex: 1;
            background: orange;
            color: white;
            font-size: 22px;
            text-align: center;
            padding: 10px 15px;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          ">
          {{ option.word }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import lottie from "vue-lottie";
import * as animationData from "../../assets/animations/speak.json";
import * as animationData2 from "../../assets/animations/success.json";
import axios from "axios";
export default {
  name: "DuzeltBakalim",
  components: { lottie },
  data() {
    return {
      pause: false,
      ps: [],
      parts: [],
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      part: 1,
      selectedWordIndex: null,
      selectedPart: null,
      options: [],
      totalTrue: 0,
      totalFalse: 0,
      totalClick: 0,
      defaultOptions: { animationData: animationData },
      defaultOptions2: { animationData: animationData2 },
      anim: null,
      sound: null,
      anim2: null,
      sounds: [],
      ii: 0,
      currentMark: 0,
      timePoints: [],
      settings: false,
      config: {
        borderOpacity: 70,
        backgroundOpacity: 100,
      },
      speed: localStorage.getItem("duzelt-bakalim-cocuklar-icin_speed")
        ? parseFloat(localStorage.getItem("duzelt-bakalim-cocuklar-icin_speed"))
        : 1,
      heceModu: "yok",
      heceRengi: "red",
      colorMode: "Kelimeler Renkli",
      isPlaying: true,
      kelimedakika: 0,
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      this.anim.stop();
    },
    handleAnimation2: function (anim) {
      this.anim2 = anim;
      this.anim2.stop();
    },
    pickOption(word) {
      this.totalClick += 1;
      if (word.isTrue) {
        this.parts[this.selectedPart].metin = this.parts[
          this.selectedPart
        ].metin.replace(
          this.parts[this.selectedPart].metin.split(" ")[
          this.selectedWordIndex
          ],
          word.word
        );

        this.parts[this.selectedPart].completedIndexes.push(
          this.selectedWordIndex
        );

        this.options = [];

        if (
          this.parts[this.selectedPart].fix.length ==
          this.parts[this.selectedPart].completedIndexes.length
        ) {
          this.part += 1;
          if (this.part > this.parts.length) {
          } else {
            this.getTts(this.parts[this.part - 1].metin);
          }
        }

        this.selectedWordIndex = null;
        this.selectedPart = null;
        this.lock = false;
        this.sounds[_.random(0, this.sounds.length - 1)].play();
        this.currentMark = 0;
        this.anim2.play();
        setTimeout(() => {
          this.anim2.stop();
        }, 2000);
      } else {
        if (this.$store.state.selectedTick2 != "sessiz")
          this.$store.state.incorrect.play();
      }
    },
    check(word, index, wordIndex) {
      if (
        this.lock ||
        index != this.part ||
        this.parts[index - 1].skipIndexes.some((k) => k == wordIndex) ||
        !this.audio.paused
      )
        return;
      this.totalClick += 1;
      if (
        this.parts[index - 1].fix.some(
          (k) => this.$slugify(k.word) == this.$slugify(word)
        )
      ) {
        if (this.$store.state.selectedTick2 != "sessiz")
          this.$store.state.correct.play();
        this.lock = true;
        this.selectedPart = index - 1;
        this.selectedWordIndex = wordIndex;
        this.options = this.parts[index - 1].fix.find(
          (k) => this.$slugify(k.word) == this.$slugify(word)
        ).options;
        this.fixIndex = this.parts[index - 1].fix.findIndex(
          (k) => this.$slugify(k.word) == this.$slugify(word)
        );

        this.parts[this.selectedPart].pendingIndexes.push(
          this.selectedWordIndex
        );

        $(".word").removeClass("animate__animated animate__tada");
        $(".word.word-" + wordIndex + "-" + index).addClass(
          "animate__animated animate__tada"
        );
        this.totalTrue += 1;
      } else {
        if (this.$store.state.selectedTick2 != "sessiz")
          this.$store.state.incorrect.play();
        this.parts[index - 1].skipIndexes.push(wordIndex);
        $(".word").removeClass("animate__animated animate__shakeX");
        $(".word.word-" + wordIndex + "-" + index).addClass(
          "animate__animated animate__shakeX"
        );
        this.totalFalse += 1;
      }
    },
    start() {
      this.currentMark = 0;
      this.part = 1;
      this.totalTrue = 0;
      this.totalFalse = 0;
      this.currentRand = _.random(0, this.ps.length - 1);
      this.parts = this.ps[this.currentRand].map((k) => {
        return {
          ...k,
          heceler: k.metin.split(" ").map((x) => this.$hecele(x)),
        };
      });
      this.getTts(this.parts[this.part - 1].metin);
    },
    getTts(text) {
      if (this.part > this.parts.length) {
        return;
      }
      axios
        .post("module/ttsWordWithSpeed", {
          text,
          gender: "male",
          id: this.currentRand + "_" + this.part + "_" + this.speed,
          speed: this.speed,
        })
        .then((res) => {
          this.timePoints = res.data.timepoints.map((k) => {
            return {
              ...k,
              timeSeconds: k.timeSeconds * 1000,
            };
          });
          this.audio = new Audio("data:audio/mp3;base64," + res.data.sound);

          this.audio.playbackRate = 1;
          this.audio.onloadedmetadata = () => {
            this.kelimedakika =
              (text.split(" ").length / this.audio.duration) * 60;
          };
          this.audio.onended = () => {
            this.anim.stop();
            clearInterval(this.interval);
            this.isPlaying = false;
          };
          this.audio.oncanplay = () => {
            this.anim.play();
            this.isPlaying = true;

            this.interval = setInterval(() => {
              if (this.pause) return;
              var a = this.timePoints
                .filter((k) => k.timeSeconds < this.audio.currentTime * 1000)
                .reverse()[0];

              this.currentMark = a ? a.markName : 0;
            }, 5);
          };
          this.audio.play();
        });
    },
    sesli(harf) {
      var sesliharfler = "âîûaeıioöuüAÎÛAEIİOÖUÜ";

      if (sesliharfler.indexOf(harf) > -1) {
        return true;
      } else {
        return false;
      }
    },
    hecele(s) {
      var ss = "";
      var hece = "";
      var boşluk = " ";
      var renkler = ["red", "blue"];
      var x = renkler.length;
      var sayaç = 0;

      var heceler = [];

      for (var i = s.length - 1; i >= 0; i--) {
        hece = s[i] + hece;
        if (
          s[i] == "'" &&
          i > 0 &&
          this.sesli(s[i - 1]) == true &&
          hece.length > 2
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
        } else if (
          s[i] == "'" &&
          i > 1 &&
          this.sesli(s[i - 1]) == false &&
          this.sesli(s[i + 1]) == true
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            s[i - 1] +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
          i--;
        } else {
          if (i == 0) {
            ss =
              "<span style='color:" +
              renkler[sayaç % x] +
              "'>" +
              hece +
              "</span>" +
              ss;
            heceler.push(hece);
            hece = "";
            sayaç++;
          } else {
            if (hece.length == 1) {
              if (
                i > 0 &&
                this.sesli(s[i]) == true &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 2) {
              if (
                hece[0] == "r" &&
                s[i - 1] == "t" &&
                this.sesli(s[i - 2]) == false
              ) {
              } else {
                if (i > 1 && s[i - 1] != "'") {
                  if (
                    this.sesli(s[i]) == false &&
                    this.sesli(s[i + 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                  if (
                    this.sesli(s[i]) == true &&
                    this.sesli(s[i - 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                } else if (
                  this.sesli(s[i]) == false &&
                  this.sesli(s[i - 1]) == true &&
                  this.sesli(s[i + 1]) == true
                ) {
                  ss =
                    "<span style='color:" +
                    renkler[sayaç % x] +
                    "'>" +
                    hece +
                    "</span>" +
                    ss;
                  heceler.push(hece);
                  hece = "";
                  sayaç++;
                }
              }
            }

            if (hece.length == 3) {
              if (i > 1) {
                if (
                  hece[0] == "r" &&
                  s[i - 1] == "t" &&
                  this.sesli(s[i - 2]) == false
                ) {
                } else {
                  if (this.sesli(s[i]) == false && s[i - 1] != "'") {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                }
              } else if (
                this.sesli(s[i]) == false &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 4) {
              ss =
                "<span style='color:" +
                renkler[sayaç % x] +
                "'>" +
                hece +
                "</span>" +
                ss;
              heceler.push(hece);
              hece = "";
              sayaç++;
            }
          }
        }
      }

      return heceler.reverse();
    },
  },
  created() {
    for (let index = 1; index < 32; index++) {
      this.ps.push(require("./duzeltbakalim/" + index + ".json"));
    }
    this.currentRand = _.random(0, this.ps.length - 1);
    this.parts = this.ps[this.currentRand];
    this.parts = this.parts.map((k) => {
      return {
        ...k,
        heceler: k.metin.split(" ").map((x) => this.$hecele(x)),
      };
    });
    this.getTts(this.parts[this.part - 1].metin);

    axios
      .post("module/tts", {
        text: "aferin süper iyigidiyorsun müthiş tebrikler",
        gender: "female",
      })
      .then((res) => {
        res.data.sounds.map((k) => {
          this.sounds.push(new Audio("data:audio/mp3;base64," + k.sound));
        });
      });

    setTimeout(() => {
      this.ps.map((p) => {
        p.map((part) => {
          var parts = part.metin.split(" ");

          part.fix.map((f) => {
            if (
              parts.some((x) => this.$slugify(x) == this.$slugify(f.word)) ===
              false
            ) {
              console.log(f.word);
            }
          });
        });
      });
    }, 1000);
  },
  watch: {
    speed: function () {
      clearTimeout(this.timeout);
      localStorage.setItem("duzelt-bakalim-cocuklar-icin_speed", this.speed);
      this.timeout = setTimeout(() => {
        this.start();
        if (this.audio) {
          this.audio.pause();
          clearInterval(this.interval);
        }
      }, 1000);
    },
    pause: function () {
      if (this.pause && this.audio) {
        this.audio.pause();
      }
      if (this.pause == false && this.audio) {
        this.audio.play();
      }
    },
  },
  beforeDestroy() {
    if (this.audio) {
      this.audio.pause();
      clearInterval(this.interval);
    }
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 800px;
  max-width: 800px;
  min-height: 700px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
  background: #eaf5f7 !important;
}

.aaaa {
  label {
    display: block;
  }

  .el-select {
    width: 100%;
  }

  .el-radio-group {
    font-size: 0;
    width: 100%;
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-direction: column;
  }
}
</style>

<style>
.el-color-picker__panel {
  z-index: 999999999999 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/DuzeltBakalimKids.vue